import React, { useEffect } from 'react';
import {
  ChakraProvider,
  Box,
  Text,
  VStack,
  Grid,
  Spinner,
  theme,
  Center,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

function Landing() {
  //loading hook
  const [loading, setLoading] = React.useState(true);

  //get url params
  const urlParams = window.location.pathname.split('/').pop();

  useEffect(() => {
    if (urlParams.includes('.$#@!%^&*')) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  });

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_APITRACKINGURL;
    const apiUrlWithParams = `${process.env.REACT_APP_APIURL}${urlParams}`;

    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        apiKey: `${process.env.REACT_APP_APIKEY}`,
      },
    };

    fetch(apiUrlWithParams, fetchOptions)
      .then(response => response.json())
      .then(res => {
        console.log(res);
        if (res.status.code === 200) {
          console.log('success');
          const fetchSendUrlCodeOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              apiKey: `${process.env.REACT_APP_APIKEY}`,
            },
            body: JSON.stringify({
              urlCode: urlParams,
              serviceType: res.status.url.serviceType,
            }),
          };
          fetch(apiUrl, fetchSendUrlCodeOptions)
            .then(response => response.json())
            .then(res => {
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
          setTimeout(() => {
            console.log('res', res);
            window.location.href = res.status.url.longUrl;
          }, 1000);
          return res;
        } else {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl">
        <Grid minH="100vh" p={3}>
          <Center>
            <VStack spacing={8}>
              {loading ? (
                <>
                  <Spinner
                    thickness="6px"
                    speed="0.50s"
                    emptyColor="gray.200"
                    color="#0244CC"
                    size="xl"
                  />
                  <Text>Redirecting...</Text>
                </>
              ) : (
                <>
                  <WarningIcon w={8} h={8} color="red.500" />
                  <Text>Error finding URL</Text>
                </>
              )}
            </VStack>
          </Center>
        </Grid>
      </Box>
    </ChakraProvider>
  );
}

export default Landing;
